import { render, staticRenderFns } from "./AppProducts.vue?vue&type=template&id=0a2e5224"
import script from "./AppProducts.vue?vue&type=script&lang=js"
export * from "./AppProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports